import { ShieldCheck } from "lucide-react";

export const GoogleButton = ({ label = "Continue with Google" }) => {
  const handle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/home";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={handle}
      data-testid="google-auth-button"
      className="w-full flex items-center justify-center gap-3 border-2 border-[#111827]/15 rounded-2xl py-4 px-6 font-semibold text-[#111827] bg-white hover:bg-[#111827]/[0.03] transition-colors min-h-[56px]"
    >
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" />
      {label}
    </button>
  );
};

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen bg-[#FFF7E6] flex flex-col">
    <div className="max-w-md w-full mx-auto px-6 py-10 flex-1 flex flex-col justify-center">
      <div className="flex items-center gap-2 mb-8">
        <div className="w-11 h-11 rounded-2xl bg-[#F97316] flex items-center justify-center shadow-md">
          <ShieldCheck className="w-6 h-6 text-white" />
        </div>
        <span className="text-xl font-bold font-head text-[#111827]">Hum<span className="text-[#F97316]">Nest</span></span>
      </div>
      <h1 className="text-3xl font-bold font-head text-[#111827] tracking-tight">{title}</h1>
      {subtitle && <p className="text-[#111827]/60 mt-2 mb-6 text-base">{subtitle}</p>}
      <div className="mt-2">{children}</div>
    </div>
  </div>
);

export const Field = ({ label, testId, ...props }) => (
  <label className="block mb-4">
    <span className="text-sm font-bold uppercase tracking-wider text-[#111827]/70">{label}</span>
    <input
      data-testid={testId}
      className="mt-1.5 bg-white border-2 border-[#111827]/15 rounded-xl p-4 text-lg focus:border-[#F97316] focus:ring-2 focus:ring-[#F97316]/20 transition-colors outline-none w-full"
      {...props}
    />
  </label>
);
